var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVkGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3002 24.9539H20.4316C20.4316 24.9539 20.779 24.9173 20.9477 24.7432C21.1065 24.5874 21.1065 24.285 21.1065 24.285C21.1065 24.285 21.0867 22.8738 21.7913 22.6722C22.4861 22.4706 23.3893 24.0284 24.3321 24.6332C25.0467 25.0914 25.5926 24.9906 25.5926 24.9906L28.1334 24.9539C28.1334 24.9539 29.4633 24.8806 28.8281 23.9184C28.7785 23.836 28.4609 23.2037 26.9424 21.9024C25.3544 20.5371 25.5628 20.757 27.4783 18.4019C28.6495 16.9633 29.116 16.0836 28.9671 15.7078C28.848 15.3505 27.9845 15.4421 27.9845 15.4421L25.1261 15.4604C25.1261 15.4604 24.9177 15.4329 24.7589 15.5246C24.61 15.607 24.5108 15.8086 24.5108 15.8086C24.5108 15.8086 24.0542 16.9174 23.4587 17.8705C22.1883 19.8681 21.6722 19.9689 21.4638 19.8498C20.9775 19.5566 21.0966 18.686 21.0966 18.0721C21.0966 16.1385 21.4142 15.3321 20.4812 15.1214C20.1736 15.0481 19.9453 15.0022 19.1513 15.0022C18.129 14.9931 17.2656 15.0022 16.7792 15.2222C16.4517 15.3688 16.2036 15.6987 16.3525 15.717C16.541 15.7445 16.9678 15.827 17.1961 16.111C17.4938 16.4776 17.474 17.3023 17.474 17.3023C17.474 17.3023 17.6427 19.5749 17.077 19.859C16.6899 20.0514 16.1639 19.6574 15.0324 17.843C14.4469 16.9083 14.0102 15.882 14.0102 15.882C14.0102 15.882 13.9308 15.6895 13.772 15.5887C13.5933 15.4604 13.3353 15.4238 13.3353 15.4238L10.6158 15.4421C10.6158 15.4421 10.2089 15.4513 10.06 15.6162C9.93101 15.7628 10.0501 16.0652 10.0501 16.0652C10.0501 16.0652 12.1741 20.6562 14.5858 22.9746C16.7991 25.0914 19.3002 24.9539 19.3002 24.9539Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVkGrey);
export default __webpack_public_path__ + "static/media/icon-vk-grey.f59e660df337cb4c8011fb529ffed09e.svg";
export { ForwardRef as ReactComponent };